<template>
  <children-tabs class='children-splice' :default-children='children' :current-row="currentRow" :formRuntimeDialog="formRuntimeDialog" />
</template>

<script>
import ChildrenTabs from './children-tabs.vue'
export default {
  name: 'children-splice',
  props: ['children', 'currentRow', 'formRuntimeDialog'],
  components: {
    ChildrenTabs
  }
}
</script>
<style lang='scss'>
.children-splice {
  .el-tabs__header {
   margin: 0px;
  }
 .pagination-list > .el-main {
    height: 100%;
    >.content{
     height: 500px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/report/runtime/children-splice.vue